import { ComponentProps } from "react";
import { NavbarLogo } from "./components/NavbarLogo/NavbarLogo";
import { NavbarContentLeft } from "./components/NavbarContentLeft";
import { NavbarContentCenter } from "./components/NavbarContentCenter";
import { NavbarContentRight } from "./components/NavbarContentRight";
import { NavbarItem } from "./components/NavbarItem";
import clsx from "clsx";

export function Navbar({ children, className, ...rest }: ComponentProps<"div">) {
  return (
    <div
      id="navbar"
      className={clsx(
        "relative flex flex-row w-full bg-background-surface-neutral text-text-base-primary shadow-md",
        "h-(--navbar-mobile-height) md:h-(--navbar-height)",
        className
      )}
      {...rest}
    >
      {children}
      <div className="absolute bottom-0 left-0 right-0 border-b border-b-blue-grey-300" />
    </div>
  );
}

Navbar.Wrapper = Navbar;
Navbar.Left = NavbarContentLeft;
Navbar.Center = NavbarContentCenter;
Navbar.Right = NavbarContentRight;
Navbar.Logo = NavbarLogo;
Navbar.Item = NavbarItem;
